<template>
  <div>
    <relatorio
      :headers="headersRel"
      :dados="relatorio"
      :filtro-config="filtroConfig"
      :exportar-p-d-f="true"
      :exportar-x-l-s-x="true"
      @exportarPdf="tipoRelatorioPdf"
      @exportarXlsx="tipoRelatorioXlsx"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td
          v-if="item.produtores"
          :colspan="headers.length"
        >
          <div>
            <v-simple-table
              dense
              class="mb-5 mt-5"
              style="border: 1px solid lightgrey; max-width: 85%;"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Data Atendimento</th>
                    <th>Setor</th>
                    <th>Matrícula</th>
                    <th>Produtor/Fazenda</th>
                    <th>CPF/CNPJ</th>
                    <th class="text-right">
                      Valor Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(itemRelacionado, index) in item.produtores"
                  >
                    <tr :key="`produtor-${index}`">
                      <td>{{ moment(itemRelacionado.data_atendimento).format('DD/MM/YYYY') }}</td>
                      <td>{{ itemRelacionado.setor }}</td>
                      <td>{{ itemRelacionado.cod }}</td>
                      <td>{{ itemRelacionado.fazenda_produtor_nome }}</td>
                      <td>{{ itemRelacionado.documento }}</td>
                      <td class="text-right">
                        R$ {{ currencyFormatter(itemRelacionado.valor_total) }}
                      </td>
                    </tr>
                    <tr
                      v-if="itemRelacionado.valor_total_produtor"
                      :key="`total-produtor-${index}`"
                    >
                      <td
                        colspan="5"
                        class="text-right"
                      >
                        <strong>Total Produtor:</strong>
                      </td>
                      <td class="text-right">
                        <strong>R$ {{ currencyFormatter(itemRelacionado?.valor_total_produtor) }}</strong>
                      </td>
                    </tr>
                  </template>

                  <tr>
                    <td
                      colspan="5"
                      class="text-right"
                    >
                      <strong>Total da empresa:</strong>
                    </td>
                    <td class="text-right">
                      <strong>R$ {{ currencyFormatter(calcTotalEmpresa(item.produtores)) }}</strong>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </td>
        <td v-else>
          Nenhum registro encontrado
        </td>
      </template>
    </relatorio>
  </div>
</template>

<script>
  import Relatorio from './Relatorio.vue'
  import { BOOTSTRAP_FORNECEDOR_RELATORIO } from '@/store/modules/fornecedores'
  import { BOOTSTRAP } from '@/store/modules/relatorio'
  import JsPDF from 'jspdf'
  import moment from 'moment'
  import { mapState } from 'vuex'
  import { mapActions } from 'vuex/dist/vuex.common.js'
  import { currencyFormatter } from '../../utils/formatter'
  import { BOOTSTRAP_SETOR_RELATORIO } from '@/store/modules/setores'
  import XLSX from 'xlsx'
  import Swal from 'sweetalert2'

  export default {
    components: {
      Relatorio,
    },
    data () {
      return {
        selecaoItem: null,
        currencyFormatter,
      }
    },
    computed: {
      ...mapState('relatorio', ['ready', 'relatorio', 'filtrosData']),
      ...mapState('fornecedores', ['ready', 'listFornecedores']),
      ...mapState('setores', ['setores']),
      headersRel () {
        return [
          { align: 'left', sortable: false, text: '', value: 'data-table-expand', width: '40px', report: false },
          { align: 'left', sortable: true, text: 'Código', value: 'codigo', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, text: 'Empresa', value: 'empresa', width: 'auto', floatingfilter: true, report: true },
        ]
      },
      filtroConfig () {
        return [
          {
            filtro: 'fornecedor',
            items: this.listFornecedores,
            itemText: 'nome',
            itemValue: 'id',
            label: 'Selecione uma empresa',
            value: [],
          },
          {
            filtro: 'setor',
            items: this.setores,
            itemText: 'descricao',
            itemValue: 'id',
            label: 'Selecione um setor',
            value: [],
          },
        ]
      },
    },
    mounted () {
      this.BOOTSTRAP_FORNECEDOR_RELATORIO()
      this.BOOTSTRAP_SETOR_RELATORIO()
    },
    methods: {
      ...mapActions('fornecedores', [BOOTSTRAP_FORNECEDOR_RELATORIO]),
      ...mapActions('relatorio', [BOOTSTRAP]),
      ...mapActions('setores', [BOOTSTRAP_SETOR_RELATORIO]),
      tipoRelatorioPdf () {
        Swal.fire({
          title: 'Informe o tipo de relatório',
          icon: 'question',
          showCancelButton: true,
          // showLoaderOnConfirm: true,
          confirmButtonColor: '#183b94',
          cancelButtonColor: '#549ACC',
          confirmButtonText: 'Sintético',
          cancelButtonText: 'Analítico',
          reverseButtons: true,
          focusConfirm: false,
        }).then(resposta => {
          Swal.close()
          if (resposta.isConfirmed) {
            this.exportPdf('sintetico')
          } else if (resposta.dismiss === Swal.DismissReason.cancel) {
            this.exportPdf('analitico')
          }
        })
      },
      tipoRelatorioXlsx () {
        Swal.fire({
          title: 'Informe o tipo de relatório',
          icon: 'question',
          showCancelButton: true,
          // showLoaderOnConfirm: true,
          confirmButtonColor: '#183b94',
          cancelButtonColor: '#549ACC',
          confirmButtonText: 'Sintético',
          cancelButtonText: 'Analítico',
          reverseButtons: true,
          focusConfirm: false,
        }).then(resposta => {
          Swal.close()
          if (resposta.isConfirmed) {
            this.exportXlsx('sintetico')
          } else if (resposta.dismiss === Swal.DismissReason.cancel) {
            this.exportXlsx('analitico')
          }
        })
      },
      async exportXlsx (tipoRelatorio) {
        const dados = this.relatorio
        const wb = XLSX.utils.book_new()
        const ws_data = []

        if (dados.length > 0) {
          let valor_total_geral = 0

          dados.forEach((dado, index) => {
            ws_data.push(['Código', 'Empresa'])
            ws_data.push([dado.codigo, dado.empresa])

            if (tipoRelatorio === 'analitico') {
              let total_empresa = 0
              ws_data.push(['Data Atendimento', 'Matrícula', 'Setor', 'Produtor/Fazenda', 'CPF/CNPJ', 'Valor Total'])
              dado.produtores.forEach(item => {
                valor_total_geral += item.valor_total
                ws_data.push([
                  moment(item.data_atendimento).format('DD/MM/YYYY'),
                  { v: item.cod, t: 's', s: { alignment: { horizontal: 'left' } } },
                  item.setor,
                  item.fazenda_produtor_nome,
                  item.documento,
                  { v: item.valor_total, t: 'n', s: { alignment: { horizontal: 'right' } } },
                ])

                total_empresa += Number(item.valor_total) || 0

                if (item.valor_total_produtor) {
                  ws_data.push(['', '', '', '', 'Total Produtor', { v: parseFloat(item.valor_total_produtor).toString().replace(',', '.'), t: 'n', s: { alignment: { horizontal: 'right' } } }])
                }
              // total_empresa += parseFloat(somarStrings(item.valor_total_produtos, item.valor_total_servicos))
              })
              ws_data.push(['', '', '', '', 'Total Empresa', { v: parseFloat(total_empresa).toString().replace(',', '.'), t: 'n', s: { alignment: { horizontal: 'right' } } }])
              if (index === dados.length - 1) {
                ws_data.push(['', '', '', '', 'Total Geral', { v: parseFloat(valor_total_geral).toString().replace(',', '.'), t: 'n', s: { alignment: { horizontal: 'right' } } }])
              }
              ws_data.push(['', '', '', ''])
            } else if (tipoRelatorio === 'sintetico') {
              ws_data.push(['Matrícula', 'Produtor/Fazenda', 'CPF/CNPJ', 'Valor Total'])
              const acumulado_produtor = []
              let total_empresa = 0

              dado.produtores.forEach(item => {
                const produtorExiste = acumulado_produtor.findIndex(ap => ap.cod === item.cod && ap.empresa_id === dado.id)
                total_empresa += item.valor_total
                valor_total_geral += item.valor_total
                if (produtorExiste !== -1) {
                  acumulado_produtor[produtorExiste].valor_total += item.valor_total
                } else {
                  acumulado_produtor.push({
                    cod: item.cod,
                    produtor: item.fazenda_produtor_nome,
                    documento: item.documento,
                    valor_total: item.valor_total,
                    empresa_id: dado.id,
                  })
                }
              })

              Object.values(acumulado_produtor).forEach(item => {
                const valorTotal = typeof item.valor_total === 'string'
                  ? parseFloat(item.valor_total.replace(',', '.'))
                  : item.valor_total

                ws_data.push([
                  item.cod,
                  item.produtor,
                  item.documento,
                  {
                    v: valorTotal.toFixed(2),
                    t: 'n',
                    s: { alignment: { horizontal: 'right' } },
                  },
                ])
              })

              const totalEmpresaNum = typeof total_empresa === 'string'
                ? parseFloat(total_empresa.replace(',', '.'))
                : total_empresa || 0

              ws_data.push([
                '',
                '',
                'Total Empresa',
                {
                  v: totalEmpresaNum.toFixed(2),
                  t: 'n',
                  s: { alignment: { horizontal: 'right' } },
                },
              ])
              if (index === dados.length - 1) {
                ws_data.push([
                  '',
                  '',
                  'Total Geral',
                  {
                    v: parseFloat(valor_total_geral).toString().replace(',', '.'),
                    t: 'n',
                    s: { alignment: { horizontal: 'right' } },
                  },
                ])
              }
              ws_data.push(['', '', '', ''])
            }
          })
        } else {
          ws_data.push(['Código', 'Empresa'])
          ws_data.push(['', '', ''])

          ws_data.push(['', '', '', ''])
          ws_data.push(['Data Atendimento', 'Matrícula', 'Setor', 'Produtor/Fazenda', 'CPF/CNPJ', 'Valor Total'])
          ws_data.push(['', '', '', ''])
          ws_data.push(['', '', '', 'Total Empresa', ''])
          ws_data.push(['', '', '', ''])
        }

        const ws = XLSX.utils.aoa_to_sheet(ws_data)

        const colWidths = ws_data[0].map((_, colIndex) =>
          ws_data.reduce((maxWidth, currentRow) => {
            const cellValue = currentRow[colIndex]
            const cellWidth = typeof cellValue === 'string' ? cellValue.length : 0
            return Math.max(maxWidth, cellWidth)
          }, 0),
        )

        ws['!cols'] = colWidths.map(width => ({ wch: width + 2 }))

        XLSX.utils.book_append_sheet(wb, ws, 'Relatório')
        XLSX.writeFile(wb, 'Relatorio.xlsx')
      },
      async exportPdf (tipoRelatorio = null) {
        const dados = this.relatorio
        let valor_total_geral = 0

        var doc = new JsPDF({
          orientation: 'portrait',
        })
        var totalPagesExp = '{total_pages_count_string}'

        const docWidth = doc.internal.pageSize.width
        const docHeight = doc.internal.pageSize.height
        const logo = await loadImageAsBase64(window.location.origin + '/img/logo.png')

        const margin = { left: 10, right: 10, bottom: 10 }
        const dateNow = moment().format('DD/MM/YYYY')
        const horaNow = moment().format('HH:mm:ss')

        function addFooter () {
          doc.text(dateNow, 12, docHeight - 10)
          doc.text('https://app.pioneiros.vet.br', docWidth / 2, docHeight - margin.bottom, { align: 'center' })
        }

        function addHeader (name, logo, doc, data_inicial, data_final) {
          doc.addImage(logo, 'png', 10, 5, 42, 12.16)
          doc.setFontSize(16)
          doc.text(name, docWidth / 2, 15, { align: 'center' })
          doc.setFontSize(8)
          doc.text(dateNow, docWidth - 10, 15, { align: 'right' })
          doc.text(horaNow, docWidth - 10, 20, { align: 'right' })
          doc.setFontSize(10)
          doc.line(margin.left, 23, docWidth - margin.right, 23)
          doc.text(
            `Período de: ${moment(data_inicial).format('DD/MM/YYYY')} até ${moment(data_final).format('DD/MM/YYYY')}`,
            10,
            27,
            { align: 'left' },
          )
        }

        async function loadImageAsBase64 (url) {
          const response = await fetch(url)
          const blob = await response.blob()

          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          })
        }

        let startY = 30.5
        if (tipoRelatorio === 'analitico') {
          dados.forEach((item, index) => {
            if (index > 0) doc.line(margin.left, startY - 1, docWidth - margin.right, startY - 1)
            const corpoTabela = []

            item.produtores.forEach((p) => {
              valor_total_geral += p.valor_total
              corpoTabela.push({
                cod: p.cod,
                setor: p.setor,
                fazenda_produtor_nome: p.fazenda_produtor_nome,
                documento: p.documento,
                valor_total: p.valor_total,
                data_atendimento: moment(p.data_atendimento).format('DD/MM/YYYY'),
              })

              if (p.valor_total_produtor > 0) {
                corpoTabela.push([
                  { content: 'Total do produtor', colSpan: 5, styles: { fontStyle: 'bold', halign: 'right' } },
                  { content: p.valor_total_produtor.toString(), styles: { fontStyle: 'bold', halign: 'right' } },
                ])
              }
            })
            corpoTabela.push([
              { content: 'Total da empresa', styles: { fontStyle: 'bold', halign: 'right' }, colSpan: 5 },
              { content: this.calcTotalEmpresa(item.produtores), styles: { fontStyle: 'bold', halign: 'right' } },
            ])
            if (index === dados.length - 1) {
              corpoTabela.push([
                { content: 'Total Geral', styles: { fontStyle: 'bold', halign: 'right' }, colSpan: 5 },
                { content: valor_total_geral, styles: { fontStyle: 'bold', halign: 'right' } },
              ])
            }

            doc.autoTable({
              theme: 'plain',
              startY: startY,
              margin: { top: 30.5, left: margin.left, bottom: 20 },
              styles: {
                textColor: 20,
                fillColor: [255, 255, 255],
                cellPadding: { top: 0, right: 5, bottom: 0, left: 0 },
                fontSize: 10,
                minCellHeight: 5,
              },
              columnStyles: {
                0: {
                  cellWidth: 'auto',
                  halign: 'left',
                },
                1: {
                  cellWidth: 'auto',
                  halign: 'left',
                },
              },
              body: [
                [
                  { content: `Código: ${item.codigo}`, styles: { cellPadding: { left: 0 } } },
                  { content: `Empresa: ${item.empresa}` },
                ],
              ],

            })
            startY = doc.previousAutoTable.finalY + 1
            doc.line(margin.left, startY - 1, docWidth - margin.right, startY - 1)
            doc.autoTable({
              theme: 'plain',
              startY: startY,
              margin: { top: 30.5, left: margin.left, right: margin.right, bottom: 20 },
              styles: {
                textColor: 20,
                fillColor: [255, 255, 255],
                cellPadding: { top: 0.5, right: 1, bottom: 1, left: 1 },
                fontSize: 7,
                minCellHeight: 5,
              },
              columns: [
                { dataKey: 'data_atendimento', header: 'Data' },
                { dataKey: 'setor', header: 'Setor' },
                { dataKey: 'cod', header: 'Matrícula' },
                { dataKey: 'fazenda_produtor_nome', header: 'Produtor/Fazenda' },
                { dataKey: 'documento', header: 'CPF/CNPJ' },
                { dataKey: 'valor_total', header: '       Valor Total' },
              ],
              columnStyles: {
                data_atendimento: { halign: 'left', cellWidth: 16 },
                documento: { halign: 'left', cellWidth: 24 },
                setor: { halign: 'left', cellWidth: 16, overflow: 'ellipsize' },
                cod: { halign: 'left', cellWidth: 17 },
                valor_total: { halign: 'right', cellWidth: 20 },
                fazenda_produtor_nome: { halign: 'left', cellWidth: 'auto', overflow: 'ellipsize' },
              },
              body: [
                ...corpoTabela,
              ],
              headStyles: { lineWidth: { top: 0, right: 0, bottom: 0.4, left: 0 }, lineColor: [0, 0, 0] },

              didParseCell: function (data) {
                const number = data.column.dataKey === 'valor_total'
                if (data.section !== 'head' && number) {
                  data.cell.text[0] = currencyFormatter(data.cell.text[0])
                }
              },
              didDrawPage: (data) => {
                const retorno = addHeader('Serviços por Empresa', logo, doc, this.filtrosData.data_inicial, this.filtrosData.data_final, data.pageNumber)

                if (retorno) return
                var str = 'Página ' + doc.internal.getNumberOfPages()
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                  str = str + ' / ' + totalPagesExp
                }
                doc.setFontSize(10)

                doc.text(str, docWidth + 25, docHeight - 10, { align: 'right' })
                addFooter()
              },
              willDrawPage: function (data) {
                const headStart = 30.5

                doc.setDrawColor(0, 0, 0)
                doc.setLineWidth(0.2)

                doc.line(
                  margin.left,
                  headStart - 1,
                  docWidth - margin.right,
                  headStart - 1,
                )
              },

            })
            startY = doc.autoTable.previous.finalY + 2
          })
          if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
          }
          startY = doc.autoTable.previous.finalY
        } if (tipoRelatorio === 'sintetico') {
          dados.forEach((item, index) => {
            if (index > 0) doc.line(margin.left, startY - 1, docWidth - margin.right, startY - 1)
            const corpoTabela = []

            item.produtores.forEach((p) => {
              valor_total_geral += p.valor_total
              if (p.valor_total_produtor) {
                corpoTabela.push({
                  cod: p.cod,
                  fazenda_produtor_nome: p.fazenda_produtor_nome,
                  documento: p.documento,
                  valor_total: p.valor_total_produtor,
                })
              }
            })
            corpoTabela.push([
              { content: 'Total da empresa', styles: { fontStyle: 'bold', halign: 'right' }, colSpan: 3 },
              { content: this.calcTotalEmpresa(item.produtores), styles: { fontStyle: 'bold', halign: 'right' } },
            ])
            if (index === dados.length - 1) {
              corpoTabela.push([
                { content: 'Total Geral', styles: { fontStyle: 'bold', halign: 'right' }, colSpan: 3 },
                { content: valor_total_geral, styles: { fontStyle: 'bold', halign: 'right' } },
              ])
            }

            doc.autoTable({
              theme: 'plain',
              startY: startY,
              margin: { top: 30.5, left: margin.left, bottom: 20 },
              styles: {
                textColor: 20,
                fillColor: [255, 255, 255],
                cellPadding: { top: 0, right: 5, bottom: 0, left: 0 },
                fontSize: 10,
                minCellHeight: 5,
              },
              columnStyles: {
                0: {
                  cellWidth: 'auto',
                  halign: 'left',
                },
                1: {
                  cellWidth: 'auto',
                  halign: 'left',
                },
              },
              body: [
                [
                  { content: `Código: ${item.codigo}`, styles: { cellPadding: { left: 0 } } },
                  { content: `Empresa: ${item.empresa}` },
                ],
              ],

            })
            startY = doc.previousAutoTable.finalY + 1
            doc.line(margin.left, startY - 1, docWidth - margin.right, startY - 1)
            doc.autoTable({
              theme: 'plain',
              startY: startY,
              margin: { top: 30.5, left: margin.left, right: margin.right, bottom: 20 },
              styles: {
                textColor: 20,
                fillColor: [255, 255, 255],
                cellPadding: { top: 0.5, right: 1, bottom: 1, left: 1 },
                fontSize: 7,
                minCellHeight: 5,
              },
              columns: [
                { dataKey: 'cod', header: 'Matrícula' },
                { dataKey: 'fazenda_produtor_nome', header: 'Produtor/Fazenda' },
                { dataKey: 'documento', header: '   CPF/CNPJ' },
                { dataKey: 'valor_total', header: '           Valor Total' },
              ],
              columnStyles: {
                cod: { halign: 'left', cellWidth: 16 },
                documento: { halign: 'right', cellWidth: 24 },
                valor_total: { halign: 'right', cellWidth: 22 },
                fazenda_produtor_nome: { halign: 'left', cellWidth: 'auto', overflow: 'ellipsize' },
              },
              body: [
                ...corpoTabela,
              ],
              headStyles: { lineWidth: { top: 0, right: 0, bottom: 0.4, left: 0 }, lineColor: [0, 0, 0] },

              didParseCell: function (data) {
                const number = data.column.dataKey === 'valor_total'
                if (data.section !== 'head' && number) {
                  data.cell.text[0] = currencyFormatter(data.cell.text[0])
                }
              },
              didDrawPage: (data) => {
                const retorno = addHeader('Serviços por Empresa', logo, doc, this.filtrosData.data_inicial, this.filtrosData.data_final, data.pageNumber)

                if (retorno) return
                var str = 'Página ' + doc.internal.getNumberOfPages()
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                  str = str + ' / ' + totalPagesExp
                }
                doc.setFontSize(10)

                doc.text(str, docWidth + 25, docHeight - 10, { align: 'right' })
                addFooter()
              },
              willDrawPage: function (data) {
                const headStart = 30.5
                doc.line(
                  margin.left,
                  headStart - 1,
                  docWidth - margin.right,
                  headStart - 1,
                )
              },
            })
            startY = doc.autoTable.previous.finalY + 2
          })
          if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
          }
          startY = doc.autoTable.previous.finalY
        }

        doc.save('Atendimentos por empresa.pdf')
      },
      calcTotalEmpresa (empresa) {
        return empresa.reduce((total, produtor) => {
          return total + produtor.valor_total
        }, 0)
      },
      calcTotalProdutor (produtor) {
        return produtor.itens.reduce((total, item) => {
          return total + (parseFloat(item.valor_total) || 0)
        }, 0)
      },
    },

  }
</script>
